import { 
    Box, 
    Typography, 
    Stack, 
    Divider 
} from "@mui/material";
import NumberControl from "components/NumberControl";


const BulkInventoryEditor = ({ products, rows, onRowsChange }) => {
    const getQty = (productId) =>
        rows.find((r) => r.productId === productId)?.allocatedQty ?? 0;

    const handleQtyChange = (product, qty) => {
        const exists = rows.some((r) => r.productId === product._id);
        if (qty > 0) {
            if (exists) {
                onRowsChange(rows.map((r) =>
                    r.productId === product._id ? { ...r, allocatedQty: qty } : r
                ));
            } else {
                onRowsChange([...rows, {
                    productId:      product._id,
                    productCode:    product.productCode || "",
                    productName:    product.productName,
                    unit:           product.unit || "",
                    category:       product.category || "",
                    unitPrice:      product.price ?? 0,
                    commissionRate: product.directCommissionRate ?? 0,
                    allocatedQty:   qty,
                }]);
            }
        } else {
            onRowsChange(rows.filter((r) => r.productId !== product._id));
        }
    };

    const productsByCategory = products.filter((p) => p.isInventory !== false).reduce((acc, p) => {
        const cat = p.category || "Other";
        if (!acc[cat]) acc[cat] = [];
        acc[cat].push(p);
        return acc;
    }, {});

    if (!products.length) return (
        <Typography variant="caption" color="text.disabled">
            No products in catalog. Download the catalog first.
        </Typography>
    );

    return (
        <Box>
            {Object.entries(productsByCategory).map(([category, catProducts], i) => (
                <Box key={category}>
                    {i > 0 && <Divider sx={{ my: 1 }} />}
                    <Typography 
                        variant="body2" 
                        color="primary.main" 
                        display="block" 
                        fontWeight={600}
                        mb={0.5} 
                    >
                        {category}
                    </Typography>
                    {catProducts.map((product) => (
                        <Stack
                            key={product._id}
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ py: 0.5 }}
                        >
                            <Box sx={{ flex: 1, mr: 1, minWidth: 0 }}>
                                <Typography variant="body2" noWrap>
                                    {product.productName}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {product.price?.toLocaleString()} · {product.unit}
                                </Typography>
                            </Box>
                            <NumberControl
                                min={0}
                                max={9999}
                                value={getQty(product._id)}
                                onChange={(v) => handleQtyChange(product, v)}
                                textFieldWidth={56}
                            />
                        </Stack>
                    ))}
                </Box>
            ))}
        </Box>
    );
};

export default BulkInventoryEditor;
